import React, { FunctionComponent } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { css } from '@emotion/react';

import { palette } from '@styles/theme';

/** Tab Option 타입 */
export interface TabOptionProps {
  label: string;
  href: string;
  active?: boolean;
}

/** 메인 컴포넌트 타입 */
interface Props {
  options: TabOptionProps[];
  isAuthCheck?: boolean;
}

/** 메인 컴포넌트 */
const Tab: FunctionComponent<Props> = ({ options, isAuthCheck = false }) => {
  const { pathname } = useLocation();

  return (
    <>
      <div css={tabWrap}>
        {isAuthCheck
          ? options
              ?.filter((f: any) => f?.active)
              ?.map((d: any) => (
                <Link to={d.href} key={d?.label}>
                  <div
                    css={[
                      tabs,
                      pathname.includes(d?.href?.split('?')?.[0]) && tabsActive,
                    ]}
                  >
                    {d?.label}
                  </div>
                </Link>
              ))
          : options.map((d: any) => (
              <Link to={d.href} key={d?.label}>
                <div
                  css={[
                    tabs,
                    pathname.includes(d?.href?.split('?')?.[0]) && tabsActive,
                  ]}
                >
                  {d?.label}
                </div>
              </Link>
            ))}
      </div>
      <div css={divider} />
    </>
  );
};

export default Tab;

const tabWrap = css`
  display: flex;
  gap: 10px;
  padding: 0 40px;
`;

const tabs = css`
  display: flex;
  width: fit-content;
  height: 50px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  align-items: center;
  justify-content: center;
  border-bottom: 3px solid transparent;
  font-weight: 500;
  padding: 0 10px;
  color: ${palette.gray4};
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    background-color: ${palette.gray2};
    opacity: 0.8;
  }
`;

const tabsActive = css`
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-color: ${palette.primaryColor};
  color: ${palette.black};
`;

const divider = css`
  width: calc(100vw - 250px);
  border-bottom: 1px solid ${palette.gray3};
`;
